import React from 'react'
import { Card, Flex, space } from '@workday/canvas-kit-react'
import { IncidentPostModel } from '../../models/IncidentPostModel'
import IncidentPostCard from './IncidentPostCard'
import { IncidentPostData } from '../../models/IncidentPostData'

export interface IncidentPostsCardProps {
  timeZone: string
  canEditPosts: boolean
  posts: IncidentPostModel[]
  onSubmit: (incidentPost: IncidentPostData, callback: (success: boolean) => void) => void
  onDelete: (incidentPost: IncidentPostData, callback: (success: boolean) => void) => void
}

const IncidentPostsCard = ({ posts, canEditPosts, timeZone, onSubmit, onDelete }: IncidentPostsCardProps) => {
  return (
    <Card>
      <Card.Heading>Incident Posts</Card.Heading>
      <Flex flexDirection="column" gap={space.s}>
        {posts.map(post => (
          <IncidentPostCard
            post={post}
            canEditPost={canEditPosts}
            timeZone={timeZone}
            onSubmit={onSubmit}
            onDelete={onDelete}
          />
        ))}
      </Flex>
    </Card>
  )
}

export default IncidentPostsCard
